import { render } from "./MaintenanceCardPC.vue?vue&type=template&id=133c5bde&scoped=true"
import script from "./MaintenanceCardPC.vue?vue&type=script&lang=js"
export * from "./MaintenanceCardPC.vue?vue&type=script&lang=js"

import "./MaintenanceCardPC.vue?vue&type=style&index=0&id=133c5bde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133c5bde"]])

export default __exports__